var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"historical-agreement-list-box"},[_vm._m(0),_c('div',{staticClass:"list-content"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"item-list"},[_c('a',{staticClass:"link",attrs:{"href":item.linkUrl}},[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-title"},[_c('h2',[_vm._v("历史版本")])])
}]

export { render, staticRenderFns }